import { createStyles } from 'antd-style';

import { ThemeColors, ThemeFont, ThemeSpaces } from '../theme';
import { absolute, flexCenter, mask } from '../styles/mixins';

export const useUserSettingsDialogStyles = createStyles(({ token }) => ({
  savingMask: {
    ...absolute(0),
    ...mask(90),
    ...flexCenter(),
    zIndex: 10,
    fontSize: token.fontSizeLG,
    fontWeight: 'bold',
  },
  notificationsScrollbar: {
    maxHeight: 451,
  },
  titleDivider: {
    marginTop: -1,
  },
  emailNotifications: {
    paddingTop: ThemeSpaces.SPACE_NORM0_5,
  },
  mapViewPreferences: {
    marginTop: token.marginSM,
  },
  segmentedControl: {
    '&.SegmentedControl': {
      height: 40,
      borderRadius: 0,
      backgroundImage: `linear-gradient(-63deg, ${ThemeColors.COLOR_GREY9_9}, ${ThemeColors.COLOR_WHITE1_5} 48%, ${ThemeColors.COLOR_GREY9_9})`,
      boxShadow: 'none',

      '.SegmentedControl-Inner:hover .SegmentedControl-Segment.active': {
        fontFamily: token.fontFamily,
        fontSize: token.fontSizeHeading4,
        fontWeight: 500,
        color: ThemeColors.COLOR_GREY_BLUISH,

        '&:hover': {
          fontFamily: token.fontFamily,
          fontSize: token.fontSizeHeading4,
          fontWeight: 500,
          color: token.colorWhite,
        },
      },
      '.SegmentedControl-Segment': {
        fontFamily: token.fontFamily,
        fontSize: token.fontSizeHeading4,
        fontWeight: 500,
        color: ThemeColors.COLOR_GREY_BLUISH,

        '&.active, &:hover': {
          fontFamily: token.fontFamily,
          fontSize: token.fontSizeHeading4,
          fontWeight: 500,
          color: token.colorWhite,
        },
      },
      '.SegmentedControl-ActiveIndicator': {
        backgroundImage: `linear-gradient(180deg, ${ThemeColors.COLOR_GREY_DARK0_5}, ${ThemeColors.COLOR_GREY_DARK0_7})`,
      },
    },
  },
  dialogWrap: {
    '&&.ant-modal-wrap.ant-modal-centered': {
      alignItems: 'flex-start',
      paddingTop: 'min(290px, calc((100vh - 800px) / 2))',

      '.ant-modal': {
        maxHeight: 800,

        '> div': {
          display: 'flex',
          flexDirection: 'column-reverse',
        },

        '.ant-modal-body': {
          position: 'relative',
          padding: `${ThemeSpaces.SPACE_NORM}px ${ThemeSpaces.SPACE_NORM_20}px`,
          alignItems: 'stretch',
        },

        '.ant-modal-content': {
          width: 400,
          minHeight: 0,
          marginTop: ThemeSpaces.SPACE_NORM_20,
        },

        form: {
          marginBottom: 0,
        },

        'h1.ant-typography': {
          lineHeight: 1,
          fontFamily: ThemeFont.FONT_CONDENSED,
          fontWeight: 'bold',
          letterSpacing: '-0.45px',
          textTransform: 'uppercase',
          marginBottom: 0,
          color: ThemeColors.COLOR_GREY_DARK0_7,
        },

        'h4.ant-typography': {
          fontSize: ThemeFont.FONT_SIZE_HEADING_3_5,
          fontWeight: 300,
          letterSpacing: '-0.24px',
          color: ThemeColors.COLOR_GREY_BLUISH5,
          marginBottom: 0,
          paddingBottom: ThemeSpaces.SPACE_NORM0_5,
          borderBottom: `1px solid ${token.colorWhite}`,
        },
      },
    },
  },
  userQuickSetupTitle: {
    position: 'relative',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    gap: ThemeSpaces.SPACE_NORM,
    color: ThemeColors.COLOR_GREY_DARK0_7,
    pointerEvents: 'auto',
  },
  userQuickSetupRow: {
    padding: `0 ${ThemeSpaces.SPACE_NORM}px`,
    '> .ant-col:first-child': {
      flex: 18,
    },
    '> .ant-col:last-child': {
      flex: 15,
    },
  },
  userQuickSetupHeaders: {
    marginTop: ThemeSpaces.SPACE_SM,
    marginBottom: ThemeSpaces.SPACE_XXS,
    fontWeight: 'bold',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',

    '.ant-col': {
      fontFamily: ThemeFont.FONT_CONDENSED,
      fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
    },
  },
  userQuickSetupRadios: {
    marginTop: token.marginSM,
    fontWeight: 'bold',

    '.ant-radio-wrapper': {
      fontFamily: ThemeFont.FONT_CONDENSED,
    },

    [`@media (max-width: ${token.screenXSMax}px)`]: {
      'label.ant-radio-wrapper': {
        fontSize: ThemeFont.FONT_SIZE_SM_PLUS,
      },
    },
  },
}));
